import { useState, useEffect, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';

import { SelectInput, MultiSelectInput } from '../forms';
import { servicePositionsActions, ServicePositionsStore } from '../../../prices/store/servicePositionStore';

type ServicePositionSelectorProps = Omit<ComponentProps<typeof SelectInput | typeof MultiSelectInput>, 'value' | 'defaultValue'> & {
    servicePositionsStore?: ServicePositionsStore,
    serviceId: number,
    multiSelect?: boolean,
    idFieldName?: string,
    excludedValues?: string[],
    // пропсы MultiSelectInput-режима (при multiSelect=true) — не входят в union ComponentProps,
    // т.к. отсутствуют у одиночного SelectInput; объявляем явно
    dropDowndzIndex?: number,
    convertPrimitives?: boolean,
  };

const ServicePositionSelector = (props: ServicePositionSelectorProps) => {
  const {
    servicePositionsStore,
    serviceId, 
    multiSelect,
    idFieldName, // по умолчанию id, но может быть positionId
    excludedValues,
    ...rest
  } = props;

  const { servicePositionsForSelector, servicePositionsForSelectorByServiceId } = servicePositionsStore;

  const [loading, setLoading] = useState(false);

  /* const getFilteredData = () => {
    let serviceData = onlyPartnerService ? partnerServices : services;
    if (typeof filter === 'function') {
      serviceData = serviceData.filter(filter);
    }
    if (onlyStationary) { serviceData = serviceData.filter(v => v.stationary); }
    if (onlyNoStationary) { serviceData = serviceData.filter(v => !v.stationary); }
    return serviceData;
  }; */

  const loadData = () => {
    if (serviceId) {
      // ✅ Проверка: не загружать, если данные для этого serviceId уже есть
      if (servicePositionsForSelectorByServiceId !== serviceId) {
        setLoading(true);
        servicePositionsActions.getServicePositionsForSelector({ serviceId })
          .finally(() => setLoading(false));
      }
    } else {
      servicePositionsActions.clearCurrentPositionForSelector();
    }
  };

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceId]);
  
  const filteredPositions = servicePositionsForSelector ?  
    servicePositionsForSelector.filter((v) => (!(excludedValues ?? []).includes(v[idFieldName ? idFieldName : 'id' ])))
    : [];

  return (
    multiSelect
      ? (
        <MultiSelectInput
          { ...rest }
          isMulti
          noOptionsMessage={ () => { return 'Нет вариантов'; } }
          data={ filteredPositions }
          dataTitle='positionName'
          dataValue={ idFieldName ? idFieldName : 'id' }
          loading={ loading }
          sort
        />
      )
      : (
        <SelectInput
          { ...rest }
          data={ filteredPositions }
          dataTitle='positionName'
          dataValue={ idFieldName ? idFieldName : 'id' }
          loading={ loading }
          sort
        />
      )

  );
};

export default inject('servicePositionsStore')(observer(ServicePositionSelector));
